import Error from '../model/Error.js';
import MemberClubFee from '../dto/MemberClubFee.js';
import axios from 'axios';

export default class MemberClubFeeRepository {
    static findByMemberAndDefaultContext(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/club-fees?context=default`)
                .then((response) => resolve(response.data.data.map((data) => MemberClubFee.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findByInvoiceRecipientAndDefaultContext(invoiceRecipientId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/invoice-recipients/${invoiceRecipientId}/member-club-fees`)
                .then((response) => resolve(response.data.data.map((data) => MemberClubFee.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(memberClubFeeId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/member-club-fees/${memberClubFeeId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
